// extracted by mini-css-extract-plugin
export default {"projectsTableContainer":"ProjectsTable_projectsTableContainer__eQ-hW"};